import styled from 'styled-components';

export const GrowContent = styled.div({
  height: 'auto',
  transformOrigin: 'top',
  transition: 'height 300ms ease-in-out',
});
